import { render } from "./PaymentOrders.vue?vue&type=template&id=45cfba8a&scoped=true"
import script from "./PaymentOrders.vue?vue&type=script&lang=js"
export * from "./PaymentOrders.vue?vue&type=script&lang=js"

import "./PaymentOrders.vue?vue&type=style&index=0&id=45cfba8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cfba8a"]])

export default __exports__